import React, {useEffect, useState} from 'react'
import {Button, message, Pagination} from "antd"
import parseToken from "../../../helpers/parseToken"
import {exportCallDetailVoiceMail, reportCallDetailVoiceMail} from "../../../services/api/apiReport"
import moment from "moment"
import ReportCallDetailSearch from "./search/ReportCallDetailSearch"
import ReportCallDetailTable from "./table/ReportCallDetailTable"
import {searchTenant} from "../../../services/api/apiUser"

const ReportCallDetailPage = () => {
    const decodeToken = parseToken()
    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState({
        page: 1,
        limit: 50,
        fromDate: moment().subtract(1, 'day').startOf('day'),
        toDate: moment().endOf('day'),
        shortPhone: '',
        tenantId: null
    })
    const [total, setTotal] = useState(0)
    const [listReports, setListReports] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingExport, setLoadingExport] = useState(false)
    const [error, setError] = useState('')
    const [tenants, setTenants] = useState([])

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onChangeLimit = (page, pageSize) => {
        setFilters({
            ...filters,
            limit: pageSize,
            page: pageSize !== filters.limit ? 1 : page
        })
    }

    const _onChangeFilters = (name, value) => {
        setFilters({
            ...filters,
            [name]: value,
            page: 1
        })
    }

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants([..._tenants])
            if (_tenants.length === 1) {
                setFilters({
                    ...filters,
                    tenantId: _tenants[0].value + ''
                })
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListReportCallDetailVoiceMail = async () => {
        setLoading(true)
        setError('')
        try {
            const payload = {
                ...filters,
                fromDate: filters.fromDate.startOf('day'),
                toDate: filters.toDate.endOf('day'),
            }

            const response = await reportCallDetailVoiceMail(payload, decodeToken.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListReports(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _onExportReport = async () => {
        setLoadingExport(true)
        try {
            const payload = {...filters}
            const response = await exportCallDetailVoiceMail(payload, decodeToken.sub);

            if (response) {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `bao_cao_chi_tiet_cuoc_goi_voice_mail_${moment().format('YYYYMMDDHHmmss')}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoadingExport(false)
            }
        } catch (e) {
            setLoadingExport(false)
            message.error(e.message);
        }
    };

    useEffect(() => {
        _fetchListReportCallDetailVoiceMail()
        // eslint-disable-next-line
    }, [filters.page, filters.limit])

    useEffect(() => {
        _fetchListTenant()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="ReportCallDetailPage PageDefault">
            <div className="PageHeading">
                <h1 className="PageTitle">Báo cáo chi tiết cuộc gọi Voice Mail</h1>
                <div className="PageFilterTop">
                    <div className="FiltersOpen" onClick={_onToggleFilter}>
                        <span className="material-icons Filter">filter_list</span>
                        <label>Bộ lọc</label>
                    </div>
                    <Button
                        className="ButtonExportAntd"
                        onClick={_onExportReport}
                        loading={loadingExport}
                        disabled={loadingExport}
                    >
                        <span className="material-icons">backup</span>
                        <span>Export</span>
                    </Button>
                </div>
            </div>

            {showFilter && <div className="Filter">
                <ReportCallDetailSearch
                    filters={filters}
                    tenants={tenants}
                    onChangeFilters={_onChangeFilters}
                    setFilters={setFilters}
                    fetchListReportCallDetailVoiceMail={_fetchListReportCallDetailVoiceMail}
                />
            </div>}

            <div className="ContentPage text-center">
                <ReportCallDetailTable error={error} loading={loading} listReports={listReports}/>
                <div className="FooterTable">
                    <div className="Total">Show all {listReports.length} / {total} items</div>
                    <Pagination
                        className="PaginationCustom"
                        showSizeChanger={false}
                        total={total}
                        current={filters.page}
                        pageSize={filters.limit}
                        itemRender={itemRender}
                        onChange={_onChangeLimit}
                    />
                </div>
            </div>
        </div>
    )
}

export default ReportCallDetailPage
